import { useState } from "react";
import axios from "axios";
import { Check } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const WaitlistForm = ({ product, testIdPrefix = "", buttonLabel = "Notify Me", promptLabel = "Be first to know", className = "" }) => {
  const [email, setEmail] = useState("");
  const [state, setState] = useState({ status: "idle", message: "" });
  const p = testIdPrefix;

  const submit = async (e) => {
    e.preventDefault();
    if (!email.trim() || state.status === "loading") return;
    setState({ status: "loading", message: "" });
    try {
      const res = await axios.post(`${API}/waitlist`, { email, product });
      setState({ status: "success", message: res.data?.message || "You're on the list" });
      setEmail("");
    } catch (err) {
      setState({
        status: "error",
        message: err.response?.data?.detail || "Something went wrong — please try again",
      });
    }
  };

  if (state.status === "success") {
    return (
      <div className={`${className} flex items-center gap-2.5 text-sm font-light text-[#3A2A25]`} data-testid={`${p}waitlist-success-message`}>
        <Check size={16} className="text-[#C9A45C] shrink-0" strokeWidth={2} />
        {state.message}
      </div>
    );
  }

  return (
    <div className={className} data-testid={`${p}waitlist-form`}>
      <p className="font-mono-accent text-[10px] uppercase tracking-[0.2em] text-[#9A8D85]">{promptLabel}</p>
      <form onSubmit={submit} className="mt-3 flex flex-col sm:flex-row gap-3">
        <input
          type="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Your email address"
          className="flex-1 px-5 py-3 rounded-full bg-[#F8F4EC] border border-[rgba(58,42,37,0.12)] text-sm font-light text-[#3A2A25] placeholder:text-[#9A8D85] focus:outline-none focus:border-[#C9A45C] transition-colors duration-300"
          data-testid={`${p}waitlist-email-input`}
        />
        <button
          type="submit"
          disabled={state.status === "loading"}
          className="px-7 py-3 rounded-full bg-[#3A2A25] text-white text-xs font-semibold uppercase tracking-[0.2em] hover:bg-[#55423A] transition-colors duration-300 disabled:opacity-60"
          data-testid={`${p}waitlist-submit-button`}
        >
          {state.status === "loading" ? "..." : buttonLabel}
        </button>
      </form>
      {state.status === "error" && (
        <p className="mt-2 text-xs text-[#C62828]" data-testid={`${p}waitlist-error-message`}>{state.message}</p>
      )}
    </div>
  );
};
